import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'

import './assets/font/iconfont.css'
import './assets/xelement.css'
import 'assets/style.css'

// import App from './App.vue'
// import router from './router/admin'

import App from './StoreApp.vue'
import router from './router/store'

Vue.use(ElementUI)

let app = new Vue({
  router,
  el: '#app',
  template: '<App/>',
  components: { App }
})
export {app, router}


// WEBPACK FOOTER //
// ./src/app.js